var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('neo-head-line',{attrs:{"realm":_vm.realm,"source":_vm.source}},[_vm._v(" "+_vm._s(_vm.name)+"("),_vm._l((_vm.params),function(param,index){return _c('span',{key:index},[_vm._v(_vm._s(param.typs.join('|') + ' ' + param.name)+_vm._s((index != (_vm.params.length - 1)) ? ', ' : ''))])}),_vm._v(") ")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }